const THEME_STORAGE_KEY = 'panel-theme';
function getPreferredTheme() {
    try {
        const saved = localStorage.getItem(THEME_STORAGE_KEY);
        if (saved === 'dark' || saved === 'light') {
            return saved;
        }
    }
    catch {
        // localStorage may be unavailable — fall back to system preference
    }
    if (window.matchMedia?.('(prefers-color-scheme: light)').matches) {
        return 'light';
    }
    return 'dark';
}
function getThemeLabel(theme) {
    return theme === 'light'
        ? { title: 'Switch to dark theme', text: '🌙' }
        : { title: 'Switch to light theme', text: '☀️' };
}
function syncThemeButtons(theme) {
    const label = getThemeLabel(theme);
    document.querySelectorAll('[data-theme-toggle]').forEach((btn) => {
        btn.textContent = label.text;
        btn.title = label.title;
        btn.setAttribute('aria-label', label.title);
        btn.dataset['theme'] = theme;
    });
}
export function getCurrentTheme() {
    const attr = document.documentElement.dataset.theme;
    if (attr === 'light' || attr === 'dark') {
        return attr;
    }
    return getPreferredTheme();
}
export function applyTheme(theme, persist = true) {
    document.documentElement.dataset.theme = theme;
    if (persist) {
        try {
            localStorage.setItem(THEME_STORAGE_KEY, theme);
        }
        catch {
            // Ignore storage failures — theme still applies in-memory.
        }
    }
    syncThemeButtons(theme);
}
export function initTheme() {
    const theme = getPreferredTheme();
    applyTheme(theme, false);
    return theme;
}
export function toggleTheme() {
    const next = getCurrentTheme() === 'dark' ? 'light' : 'dark';
    applyTheme(next);
    return next;
}
export function createThemeToggleButton(className = '') {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = ['theme-toggle-btn', className].filter(Boolean).join(' ');
    button.dataset['themeToggle'] = '1';
    const label = getThemeLabel(getCurrentTheme());
    button.textContent = label.text;
    button.title = label.title;
    button.setAttribute('aria-label', label.title);
    button.dataset['theme'] = getCurrentTheme();
    button.addEventListener('click', () => {
        toggleTheme();
    });
    syncThemeButtons(getCurrentTheme());
    return button;
}
